// extracted by mini-css-extract-plugin
module.exports = {"rentalBadge":"r4","isKids":"r5","rentalBadgeWrapper":"r6","isGrid":"r7","hide":"r8"};